import './error.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { configureSite } from './config/siteConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Initialize site configuration before rendering the app
configureSite()
  .then(() => {
    root.render(<App />);
  })
  .catch((error) => {
    root.render(
      <div className="error-container">
        <h1>Configuration Error</h1>
        <p>Failed to load application configuration. Please check appsettings.json file.</p>
        <pre className="error-details">
          {error.message}
        </pre>
      </div>
    );
  });
